/* eslint-disable */
/* ***********************************************************
* A short word on how to use this automagically generated file.
* We're often asked in the ignite gitter channel how to connect
* to a to a third party api, so we thought we'd demonstrate - but
* you should know you can use sagas for other flow control too.
*
* Other points:
*  - You'll need to add this saga to sagas/index.js
*  - This template uses the api declared in sagas/index.js, so
*    you'll need to define a constant in that file.
*************************************************************/

import { call, put } from 'redux-saga/effects'
import ShareActions from '../Redux/ShareRedux'
// import { ShareSelectors } from '../Redux/ShareRedux'

export function* getFacebookStatus(api, action) {
  try {
    const { data } = action

    const response = yield call(api.getFacebookStatus, {})
    const test = yield call(api.getTmpUrl, {})
    console.tron.display({
    name: `getTmpUrl`,
     preview :``,
    value: {
    state: test
    }
    })
    
    if (response.ok) {
      console.tron.display({
        name: `getFacebookStatus sucess`,
        preview: ``,
        value: {
          state: response
        }
      })

      yield put(ShareActions.getFacebookSuccess(response))
    } else {
      console.tron.display({
        name: `getFacebookStatus fail`,
        preview: ``,
        value: {
          state: response
        }
      })
      yield put(ShareActions.getFacebookFailure())
    }
  } catch (e) {
    console.tron.display({
      name: `getFacebookStatus error`,
      preview: ``,
      value: {
        state: e
      }
    })
    yield put(ShareActions.getFacebookFailure())
  }

}
export function* getTmpUrl(api, action) {
  try {
    const { data } = action

    const response = yield call(api.getTmpUrl, data)

    if (response.ok) {
      console.tron.display({
        name: `getTmpUrl sucess`,
        preview: ``,
        value: {
          state: response
        }
      })

      yield put(ShareActions.getTmpUrlSuccess(response))
    } else {
      console.tron.display({
        name: `getTmpUrl fail`,
        preview: ``,
        value: {
          state: response
        }
      })
      yield put(ShareActions.getTmpUrlFailure())
    }
  } catch (e) {
    console.tron.display({
      name: `getTmpUrl error`,
      preview: ``,
      value: {
        state: e
      }
    })
    yield put(ShareActions.getTmpUrlFailure())
  }

}
